import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ClockIcon from '@atlaskit/icon/core/clock';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.date-time-picker-field.icon-label',
		defaultMessage: 'Date time picker field icon',
		description: 'Label for the date time picker field icon',
	},
});

export function DateTimePickerFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<ClockIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
